import type { LabelHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { tokens, Tooltip } from '@hotjar/hotsauce';

const Label = styled.label<{ withTooltip: boolean }>`
  ${tokens.text('subtitle2')}
  color: ${tokens.color.text_default};
  text-transform: none;
  display: inline-block;
  margin: 0;

  ${(p) =>
    p.withTooltip &&
    `
    border-bottom: 1px dashed black;
    cursor: help;
  `}
`;

interface WizardLabelProps extends LabelHTMLAttributes<HTMLInputElement> {
  tooltipText?: string;
}

export function WizardLabel(props: WizardLabelProps): JSX.Element {
  const { children, tooltipText = '', htmlFor } = props;

  const withTooltip = tooltipText !== '';

  return (
    <Tooltip text={tooltipText} isDisabled={!withTooltip}>
      <Label withTooltip={withTooltip} htmlFor={htmlFor}>
        {children}
      </Label>
    </Tooltip>
  );
}
